import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UploadExcelFileMutationVariables = Types.Exact<{
  fileBase64: Types.Scalars['String']['input'];
  fileName: Types.Scalars['String']['input'];
}>;


export type UploadExcelFileMutation = { __typename?: 'Mutation', obtUploadExcelFile: Array<{ __typename?: 'IObtUploadResponse', partnerno?: string | null, companycode?: string | null, sysid?: string | null, category?: string | null }> };

export type UploadPartnerContactsFileMutationVariables = Types.Exact<{
  fileBase64: Types.Scalars['String']['input'];
  fileName: Types.Scalars['String']['input'];
}>;


export type UploadPartnerContactsFileMutation = { __typename?: 'Mutation', obtUploadPartnerContactsFile: Array<{ __typename?: 'IObtContactModel', idpartner?: number | null, partnerno?: string | null, companycode?: string | null, role?: string | null, source?: string | null, name1?: string | null, name2?: string | null, department?: string | null, phone?: string | null, fax?: string | null, mail?: string | null }> };

export type UpdateCompanyLeitwegIdMutationVariables = Types.Exact<{
  leitwegid: Types.Scalars['String']['input'];
  leitwegsemail: Types.Scalars['String']['input'];
  idpartner: Types.Scalars['Float']['input'];
  partnerno: Types.Scalars['String']['input'];
  companycode: Types.Scalars['String']['input'];
}>;


export type UpdateCompanyLeitwegIdMutation = { __typename?: 'Mutation', obtUpdateCompanyLeitwegID: string };

export type RemoveCompanyLeitwegIdMutationVariables = Types.Exact<{
  idpartner: Types.Scalars['Float']['input'];
  partnerno: Types.Scalars['String']['input'];
  companycode: Types.Scalars['String']['input'];
}>;


export type RemoveCompanyLeitwegIdMutation = { __typename?: 'Mutation', obtRemoveCompanyLeitwegID: string };

export type UpdateMasterPartnerNoMutationVariables = Types.Exact<{
  masterpartnerno: Types.Scalars['String']['input'];
  partnerno: Types.Scalars['String']['input'];
  idpartner: Types.Scalars['Float']['input'];
}>;


export type UpdateMasterPartnerNoMutation = { __typename?: 'Mutation', obtUpdateMasterPartnerNo: string };

export type CancelPartnerChannelMutationVariables = Types.Exact<{
  channelId: Types.Scalars['Float']['input'];
  validTo: Types.Scalars['String']['input'];
  status: Types.Scalars['String']['input'];
}>;


export type CancelPartnerChannelMutation = { __typename?: 'Mutation', obtCancelPartnerChannel: string };

export type UpdateContactStatusMutationVariables = Types.Exact<{
  idContact: Types.Scalars['Float']['input'];
}>;


export type UpdateContactStatusMutation = { __typename?: 'Mutation', obtUpdateContactStatus?: number | null };

export type UpdatePartnerLegalVatCodeMutationVariables = Types.Exact<{
  partnerno: Types.Scalars['String']['input'];
  idpartner: Types.Scalars['Float']['input'];
  vatCode: Types.Scalars['String']['input'];
}>;


export type UpdatePartnerLegalVatCodeMutation = { __typename?: 'Mutation', obtUpdatePartnerLegalVatCode?: { __typename?: 'ObtPartnerVatNipCodeResult', success?: boolean | null, message?: string | null } | null };

export type DeletePartnerLegalVatCodeMutationVariables = Types.Exact<{
  partnerno: Types.Scalars['String']['input'];
  idpartner: Types.Scalars['Float']['input'];
  vatCode: Types.Scalars['String']['input'];
}>;


export type DeletePartnerLegalVatCodeMutation = { __typename?: 'Mutation', obtDeletePartnerLegalVatCode?: { __typename?: 'ObtPartnerVatNipCodeResult', success?: boolean | null, message?: string | null } | null };

export type UpdateCompanyPeppolIdMutationVariables = Types.Exact<{
  peppolId: Types.Scalars['String']['input'];
  idpartner: Types.Scalars['Float']['input'];
  partnerno: Types.Scalars['String']['input'];
  companycode: Types.Scalars['String']['input'];
}>;


export type UpdateCompanyPeppolIdMutation = { __typename?: 'Mutation', obtUpdateCompanyPeppolID: string };

export type RemoveCompanyPeppolIdMutationVariables = Types.Exact<{
  idpartner: Types.Scalars['Float']['input'];
  partnerno: Types.Scalars['String']['input'];
  companycode: Types.Scalars['String']['input'];
}>;


export type RemoveCompanyPeppolIdMutation = { __typename?: 'Mutation', obtRemoveCompanyPeppolID: string };


export const UploadExcelFileDocument = gql`
    mutation uploadExcelFile($fileBase64: String!, $fileName: String!) {
  obtUploadExcelFile(fileBase64: $fileBase64, fileName: $fileName) {
    partnerno
    companycode
    sysid
    category
  }
}
    `;
export type UploadExcelFileMutationFn = Apollo.MutationFunction<UploadExcelFileMutation, UploadExcelFileMutationVariables>;

/**
 * __useUploadExcelFileMutation__
 *
 * To run a mutation, you first call `useUploadExcelFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadExcelFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadExcelFileMutation, { data, loading, error }] = useUploadExcelFileMutation({
 *   variables: {
 *      fileBase64: // value for 'fileBase64'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useUploadExcelFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadExcelFileMutation, UploadExcelFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadExcelFileMutation, UploadExcelFileMutationVariables>(UploadExcelFileDocument, options);
      }
export type UploadExcelFileMutationHookResult = ReturnType<typeof useUploadExcelFileMutation>;
export type UploadExcelFileMutationResult = Apollo.MutationResult<UploadExcelFileMutation>;
export type UploadExcelFileMutationOptions = Apollo.BaseMutationOptions<UploadExcelFileMutation, UploadExcelFileMutationVariables>;
export const UploadPartnerContactsFileDocument = gql`
    mutation uploadPartnerContactsFile($fileBase64: String!, $fileName: String!) {
  obtUploadPartnerContactsFile(fileBase64: $fileBase64, fileName: $fileName) {
    idpartner
    partnerno
    companycode
    role
    source
    name1
    name2
    department
    phone
    fax
    mail
  }
}
    `;
export type UploadPartnerContactsFileMutationFn = Apollo.MutationFunction<UploadPartnerContactsFileMutation, UploadPartnerContactsFileMutationVariables>;

/**
 * __useUploadPartnerContactsFileMutation__
 *
 * To run a mutation, you first call `useUploadPartnerContactsFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPartnerContactsFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPartnerContactsFileMutation, { data, loading, error }] = useUploadPartnerContactsFileMutation({
 *   variables: {
 *      fileBase64: // value for 'fileBase64'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useUploadPartnerContactsFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadPartnerContactsFileMutation, UploadPartnerContactsFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadPartnerContactsFileMutation, UploadPartnerContactsFileMutationVariables>(UploadPartnerContactsFileDocument, options);
      }
export type UploadPartnerContactsFileMutationHookResult = ReturnType<typeof useUploadPartnerContactsFileMutation>;
export type UploadPartnerContactsFileMutationResult = Apollo.MutationResult<UploadPartnerContactsFileMutation>;
export type UploadPartnerContactsFileMutationOptions = Apollo.BaseMutationOptions<UploadPartnerContactsFileMutation, UploadPartnerContactsFileMutationVariables>;
export const UpdateCompanyLeitwegIdDocument = gql`
    mutation updateCompanyLeitwegID($leitwegid: String!, $leitwegsemail: String!, $idpartner: Float!, $partnerno: String!, $companycode: String!) {
  obtUpdateCompanyLeitwegID(
    leitwegid: $leitwegid
    leitwegsemail: $leitwegsemail
    idpartner: $idpartner
    partnerno: $partnerno
    companycode: $companycode
  )
}
    `;
export type UpdateCompanyLeitwegIdMutationFn = Apollo.MutationFunction<UpdateCompanyLeitwegIdMutation, UpdateCompanyLeitwegIdMutationVariables>;

/**
 * __useUpdateCompanyLeitwegIdMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyLeitwegIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyLeitwegIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyLeitwegIdMutation, { data, loading, error }] = useUpdateCompanyLeitwegIdMutation({
 *   variables: {
 *      leitwegid: // value for 'leitwegid'
 *      leitwegsemail: // value for 'leitwegsemail'
 *      idpartner: // value for 'idpartner'
 *      partnerno: // value for 'partnerno'
 *      companycode: // value for 'companycode'
 *   },
 * });
 */
export function useUpdateCompanyLeitwegIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyLeitwegIdMutation, UpdateCompanyLeitwegIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyLeitwegIdMutation, UpdateCompanyLeitwegIdMutationVariables>(UpdateCompanyLeitwegIdDocument, options);
      }
export type UpdateCompanyLeitwegIdMutationHookResult = ReturnType<typeof useUpdateCompanyLeitwegIdMutation>;
export type UpdateCompanyLeitwegIdMutationResult = Apollo.MutationResult<UpdateCompanyLeitwegIdMutation>;
export type UpdateCompanyLeitwegIdMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyLeitwegIdMutation, UpdateCompanyLeitwegIdMutationVariables>;
export const RemoveCompanyLeitwegIdDocument = gql`
    mutation removeCompanyLeitwegID($idpartner: Float!, $partnerno: String!, $companycode: String!) {
  obtRemoveCompanyLeitwegID(
    idpartner: $idpartner
    partnerno: $partnerno
    companycode: $companycode
  )
}
    `;
export type RemoveCompanyLeitwegIdMutationFn = Apollo.MutationFunction<RemoveCompanyLeitwegIdMutation, RemoveCompanyLeitwegIdMutationVariables>;

/**
 * __useRemoveCompanyLeitwegIdMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyLeitwegIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyLeitwegIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyLeitwegIdMutation, { data, loading, error }] = useRemoveCompanyLeitwegIdMutation({
 *   variables: {
 *      idpartner: // value for 'idpartner'
 *      partnerno: // value for 'partnerno'
 *      companycode: // value for 'companycode'
 *   },
 * });
 */
export function useRemoveCompanyLeitwegIdMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyLeitwegIdMutation, RemoveCompanyLeitwegIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyLeitwegIdMutation, RemoveCompanyLeitwegIdMutationVariables>(RemoveCompanyLeitwegIdDocument, options);
      }
export type RemoveCompanyLeitwegIdMutationHookResult = ReturnType<typeof useRemoveCompanyLeitwegIdMutation>;
export type RemoveCompanyLeitwegIdMutationResult = Apollo.MutationResult<RemoveCompanyLeitwegIdMutation>;
export type RemoveCompanyLeitwegIdMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyLeitwegIdMutation, RemoveCompanyLeitwegIdMutationVariables>;
export const UpdateMasterPartnerNoDocument = gql`
    mutation updateMasterPartnerNo($masterpartnerno: String!, $partnerno: String!, $idpartner: Float!) {
  obtUpdateMasterPartnerNo(
    masterpartnerno: $masterpartnerno
    partnerno: $partnerno
    idpartner: $idpartner
  )
}
    `;
export type UpdateMasterPartnerNoMutationFn = Apollo.MutationFunction<UpdateMasterPartnerNoMutation, UpdateMasterPartnerNoMutationVariables>;

/**
 * __useUpdateMasterPartnerNoMutation__
 *
 * To run a mutation, you first call `useUpdateMasterPartnerNoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterPartnerNoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterPartnerNoMutation, { data, loading, error }] = useUpdateMasterPartnerNoMutation({
 *   variables: {
 *      masterpartnerno: // value for 'masterpartnerno'
 *      partnerno: // value for 'partnerno'
 *      idpartner: // value for 'idpartner'
 *   },
 * });
 */
export function useUpdateMasterPartnerNoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMasterPartnerNoMutation, UpdateMasterPartnerNoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMasterPartnerNoMutation, UpdateMasterPartnerNoMutationVariables>(UpdateMasterPartnerNoDocument, options);
      }
export type UpdateMasterPartnerNoMutationHookResult = ReturnType<typeof useUpdateMasterPartnerNoMutation>;
export type UpdateMasterPartnerNoMutationResult = Apollo.MutationResult<UpdateMasterPartnerNoMutation>;
export type UpdateMasterPartnerNoMutationOptions = Apollo.BaseMutationOptions<UpdateMasterPartnerNoMutation, UpdateMasterPartnerNoMutationVariables>;
export const CancelPartnerChannelDocument = gql`
    mutation cancelPartnerChannel($channelId: Float!, $validTo: String!, $status: String!) {
  obtCancelPartnerChannel(
    channelId: $channelId
    validTo: $validTo
    status: $status
  )
}
    `;
export type CancelPartnerChannelMutationFn = Apollo.MutationFunction<CancelPartnerChannelMutation, CancelPartnerChannelMutationVariables>;

/**
 * __useCancelPartnerChannelMutation__
 *
 * To run a mutation, you first call `useCancelPartnerChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPartnerChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPartnerChannelMutation, { data, loading, error }] = useCancelPartnerChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      validTo: // value for 'validTo'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCancelPartnerChannelMutation(baseOptions?: Apollo.MutationHookOptions<CancelPartnerChannelMutation, CancelPartnerChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPartnerChannelMutation, CancelPartnerChannelMutationVariables>(CancelPartnerChannelDocument, options);
      }
export type CancelPartnerChannelMutationHookResult = ReturnType<typeof useCancelPartnerChannelMutation>;
export type CancelPartnerChannelMutationResult = Apollo.MutationResult<CancelPartnerChannelMutation>;
export type CancelPartnerChannelMutationOptions = Apollo.BaseMutationOptions<CancelPartnerChannelMutation, CancelPartnerChannelMutationVariables>;
export const UpdateContactStatusDocument = gql`
    mutation updateContactStatus($idContact: Float!) {
  obtUpdateContactStatus(idContact: $idContact)
}
    `;
export type UpdateContactStatusMutationFn = Apollo.MutationFunction<UpdateContactStatusMutation, UpdateContactStatusMutationVariables>;

/**
 * __useUpdateContactStatusMutation__
 *
 * To run a mutation, you first call `useUpdateContactStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactStatusMutation, { data, loading, error }] = useUpdateContactStatusMutation({
 *   variables: {
 *      idContact: // value for 'idContact'
 *   },
 * });
 */
export function useUpdateContactStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactStatusMutation, UpdateContactStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactStatusMutation, UpdateContactStatusMutationVariables>(UpdateContactStatusDocument, options);
      }
export type UpdateContactStatusMutationHookResult = ReturnType<typeof useUpdateContactStatusMutation>;
export type UpdateContactStatusMutationResult = Apollo.MutationResult<UpdateContactStatusMutation>;
export type UpdateContactStatusMutationOptions = Apollo.BaseMutationOptions<UpdateContactStatusMutation, UpdateContactStatusMutationVariables>;
export const UpdatePartnerLegalVatCodeDocument = gql`
    mutation updatePartnerLegalVatCode($partnerno: String!, $idpartner: Float!, $vatCode: String!) {
  obtUpdatePartnerLegalVatCode(
    partnerno: $partnerno
    idpartner: $idpartner
    vatCode: $vatCode
  ) {
    success
    message
  }
}
    `;
export type UpdatePartnerLegalVatCodeMutationFn = Apollo.MutationFunction<UpdatePartnerLegalVatCodeMutation, UpdatePartnerLegalVatCodeMutationVariables>;

/**
 * __useUpdatePartnerLegalVatCodeMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerLegalVatCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerLegalVatCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerLegalVatCodeMutation, { data, loading, error }] = useUpdatePartnerLegalVatCodeMutation({
 *   variables: {
 *      partnerno: // value for 'partnerno'
 *      idpartner: // value for 'idpartner'
 *      vatCode: // value for 'vatCode'
 *   },
 * });
 */
export function useUpdatePartnerLegalVatCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerLegalVatCodeMutation, UpdatePartnerLegalVatCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerLegalVatCodeMutation, UpdatePartnerLegalVatCodeMutationVariables>(UpdatePartnerLegalVatCodeDocument, options);
      }
export type UpdatePartnerLegalVatCodeMutationHookResult = ReturnType<typeof useUpdatePartnerLegalVatCodeMutation>;
export type UpdatePartnerLegalVatCodeMutationResult = Apollo.MutationResult<UpdatePartnerLegalVatCodeMutation>;
export type UpdatePartnerLegalVatCodeMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerLegalVatCodeMutation, UpdatePartnerLegalVatCodeMutationVariables>;
export const DeletePartnerLegalVatCodeDocument = gql`
    mutation deletePartnerLegalVatCode($partnerno: String!, $idpartner: Float!, $vatCode: String!) {
  obtDeletePartnerLegalVatCode(
    partnerno: $partnerno
    idpartner: $idpartner
    vatCode: $vatCode
  ) {
    success
    message
  }
}
    `;
export type DeletePartnerLegalVatCodeMutationFn = Apollo.MutationFunction<DeletePartnerLegalVatCodeMutation, DeletePartnerLegalVatCodeMutationVariables>;

/**
 * __useDeletePartnerLegalVatCodeMutation__
 *
 * To run a mutation, you first call `useDeletePartnerLegalVatCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartnerLegalVatCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartnerLegalVatCodeMutation, { data, loading, error }] = useDeletePartnerLegalVatCodeMutation({
 *   variables: {
 *      partnerno: // value for 'partnerno'
 *      idpartner: // value for 'idpartner'
 *      vatCode: // value for 'vatCode'
 *   },
 * });
 */
export function useDeletePartnerLegalVatCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePartnerLegalVatCodeMutation, DeletePartnerLegalVatCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePartnerLegalVatCodeMutation, DeletePartnerLegalVatCodeMutationVariables>(DeletePartnerLegalVatCodeDocument, options);
      }
export type DeletePartnerLegalVatCodeMutationHookResult = ReturnType<typeof useDeletePartnerLegalVatCodeMutation>;
export type DeletePartnerLegalVatCodeMutationResult = Apollo.MutationResult<DeletePartnerLegalVatCodeMutation>;
export type DeletePartnerLegalVatCodeMutationOptions = Apollo.BaseMutationOptions<DeletePartnerLegalVatCodeMutation, DeletePartnerLegalVatCodeMutationVariables>;
export const UpdateCompanyPeppolIdDocument = gql`
    mutation updateCompanyPeppolID($peppolId: String!, $idpartner: Float!, $partnerno: String!, $companycode: String!) {
  obtUpdateCompanyPeppolID(
    peppolId: $peppolId
    idpartner: $idpartner
    partnerno: $partnerno
    companycode: $companycode
  )
}
    `;
export type UpdateCompanyPeppolIdMutationFn = Apollo.MutationFunction<UpdateCompanyPeppolIdMutation, UpdateCompanyPeppolIdMutationVariables>;

/**
 * __useUpdateCompanyPeppolIdMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyPeppolIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyPeppolIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyPeppolIdMutation, { data, loading, error }] = useUpdateCompanyPeppolIdMutation({
 *   variables: {
 *      peppolId: // value for 'peppolId'
 *      idpartner: // value for 'idpartner'
 *      partnerno: // value for 'partnerno'
 *      companycode: // value for 'companycode'
 *   },
 * });
 */
export function useUpdateCompanyPeppolIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyPeppolIdMutation, UpdateCompanyPeppolIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyPeppolIdMutation, UpdateCompanyPeppolIdMutationVariables>(UpdateCompanyPeppolIdDocument, options);
      }
export type UpdateCompanyPeppolIdMutationHookResult = ReturnType<typeof useUpdateCompanyPeppolIdMutation>;
export type UpdateCompanyPeppolIdMutationResult = Apollo.MutationResult<UpdateCompanyPeppolIdMutation>;
export type UpdateCompanyPeppolIdMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyPeppolIdMutation, UpdateCompanyPeppolIdMutationVariables>;
export const RemoveCompanyPeppolIdDocument = gql`
    mutation removeCompanyPeppolID($idpartner: Float!, $partnerno: String!, $companycode: String!) {
  obtRemoveCompanyPeppolID(
    idpartner: $idpartner
    partnerno: $partnerno
    companycode: $companycode
  )
}
    `;
export type RemoveCompanyPeppolIdMutationFn = Apollo.MutationFunction<RemoveCompanyPeppolIdMutation, RemoveCompanyPeppolIdMutationVariables>;

/**
 * __useRemoveCompanyPeppolIdMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyPeppolIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyPeppolIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyPeppolIdMutation, { data, loading, error }] = useRemoveCompanyPeppolIdMutation({
 *   variables: {
 *      idpartner: // value for 'idpartner'
 *      partnerno: // value for 'partnerno'
 *      companycode: // value for 'companycode'
 *   },
 * });
 */
export function useRemoveCompanyPeppolIdMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyPeppolIdMutation, RemoveCompanyPeppolIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyPeppolIdMutation, RemoveCompanyPeppolIdMutationVariables>(RemoveCompanyPeppolIdDocument, options);
      }
export type RemoveCompanyPeppolIdMutationHookResult = ReturnType<typeof useRemoveCompanyPeppolIdMutation>;
export type RemoveCompanyPeppolIdMutationResult = Apollo.MutationResult<RemoveCompanyPeppolIdMutation>;
export type RemoveCompanyPeppolIdMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyPeppolIdMutation, RemoveCompanyPeppolIdMutationVariables>;